import { render, staticRenderFns } from "./grid-item.vue?vue&type=template&id=e2b06bc2"
import script from "./grid-item.vue?vue&type=script&lang=js"
export * from "./grid-item.vue?vue&type=script&lang=js"
import style0 from "./grid-item.vue?vue&type=style&index=0&id=e2b06bc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports